export default __webpack_public_path__ + "static/media/AB1_investor_slider_img.508eaf2e.png";